import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPadlock = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.08332 3.74992V2.91659C7.08332 1.74992 6.16666 0.833252 4.99999 0.833252C3.83332 0.833252 2.91666 1.74992 2.91666 2.91659V3.74992C2.20832 3.74992 1.66666 4.29159 1.66666 4.99992V7.91658C1.66666 8.62492 2.20832 9.16658 2.91666 9.16658H7.08332C7.79166 9.16658 8.33332 8.62492 8.33332 7.91658V4.99992C8.33332 4.29159 7.79166 3.74992 7.08332 3.74992ZM3.74999 2.91659C3.74999 2.20825 4.29166 1.66659 4.99999 1.66659C5.70832 1.66659 6.24999 2.20825 6.24999 2.91659V3.74992H3.74999V2.91659ZM5.45832 6.45825L5.41666 6.49992V7.08325C5.41666 7.33325 5.24999 7.49992 4.99999 7.49992C4.74999 7.49992 4.58332 7.33325 4.58332 7.08325V6.49992C4.33332 6.24992 4.29166 5.87492 4.54166 5.62492C4.79166 5.37492 5.16666 5.33325 5.41666 5.58325C5.66666 5.79158 5.70832 6.20825 5.45832 6.45825Z",
		fill: "white"
	})
});
export default SvgPadlock;
